<template>
  <div>
    <div class="wrapper">
      <app-sidebar />

      <div class="main">
        <app-navbar />

        <main class="content">
          <div class="container-fluid">
            <router-view />
          </div>
        </main>
        
        <app-footer />
      </div>
    </div>
  </div>
</template>

<script>
import AppNavbar from './dashboard/shared/Navbar.vue'
import AppSidebar from './dashboard/shared/Sidebar.vue'
import AppFooter from './dashboard/shared/Footer.vue'

export default {
  components: {
    AppNavbar, AppSidebar, AppFooter
  },

  mounted() {
    if (! this.$storage.has("token")) {
      return this.$router.push({ name: "login" });
    }

    if (this.$store.getters.getAuthUser.role != 'customer') { 
      return this.$router.push({ name: "main" });
    }
  }
};
</script>
